module.exports = __webpack_public_path__ + "static/media/hh-bg-yellow.305fa3a0.png";